/** @format */
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import GlitterTexture from '@toucan/images/glitter-texture.svg';

import { DEFAULT_TEST_ID } from './constants';
import { styles } from './holographic-background.styles';
import { holographicBackgroundProps } from './types';

const StyledHolographicBackground = styled.div`
    ${styles}
`;

export const HolographicBackground: FunctionComponent<
    holographicBackgroundProps
> = ({
    children,
    'data-testid': dataTestId = DEFAULT_TEST_ID,
    ...otherProps
}) => {
    return (
        <StyledHolographicBackground data-testid={dataTestId} {...otherProps}>
            <div
                data-testid={`${dataTestId}__background-container`}
                className="background-container"
            >
                <div className="glitter-texture">
                    <GlitterTexture />
                </div>
            </div>
            {children}
        </StyledHolographicBackground>
    );
};
